<template>
	<div class="gallery-single">
		<div v-for="(item, index) in items" :key="index">
			<Cover :class="'gallery-single__cover--' + type" :item="item" :type="type" />
			<Caption v-if="$path(item, 'caption')" :item="item" />
		</div>
	</div>
</template>

<script>
import Caption from '../Caption.vue'
import Cover from '../Cover.vue'

export default {
	props: {
		items: {
			type: Array,
			default: () => ({}),
		},
		type: {
			type: String,
			default: 'cover',
		},
	},
	computed: {},
	components: {
		Caption,
		Cover,
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.gallery-single {
	width: 100%;
	display: grid;
	grid-gap: 5rem 0;
	grid-template-columns: 1fr;

	&__cover {
		&--single--small {
			max-width: 560px;
			margin: 0 auto;
		}
		&--single--medium {
			max-width: 774px;
			margin: 0 auto;
		}
		&--single--large {
			max-width: 1200px;
			margin: 0 auto;
		}
	}
}
</style>
